import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import type { PromoCode } from '@store/api/interfaces';
import { useUserStore } from '@store/user';

const STORAGE_KEY = 'payment_promo_code';

export const usePaymentFlowStore = defineStore('paymentFlow', () => {
	const userStore = useUserStore();

	// Restore promo code from storage (only relevant for unauthenticated users)
	const savedPromo = localStorage.getItem(STORAGE_KEY) || '';

	const selectedMonths = ref<number | null>(null);
	const promoCode = ref<string>(savedPromo);
	const appliedPromo = ref<PromoCode | null>(null);

	// Persist promo code to localStorage only when not authenticated; always allow removal
	watch(promoCode, (value) => {
		if (value) {
			if (!userStore.loggedIn) {
				localStorage.setItem(STORAGE_KEY, value);
			}
		} else {
			localStorage.removeItem(STORAGE_KEY);
		}
	});

	const clearStorage = () => {
		localStorage.removeItem(STORAGE_KEY);
	};

	// Promo the backend rejected: forget it so no page puts it back into ?promo=
	// (the watcher above also drops it from localStorage)
	const clearPromo = () => {
		promoCode.value = '';
		appliedPromo.value = null;
	};

	const reset = () => {
		selectedMonths.value = null;
		clearPromo();
		clearStorage();
	};

	return {
		selectedMonths,
		promoCode,
		appliedPromo,
		clearStorage,
		clearPromo,
		reset
	};
});
